module.exports = __webpack_public_path__ + "img/topic-earring.1306eddb.jpg";